// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"23":"299a7788","95":"c7064ce4","176":"3dca9255","309":"545cf4e1","488":"c77a10b1","570":"776569a0","733":"5b2703b6","790":"e07755c7","974":"90908b90"}[chunkId] + ".chunk.js";
};